// NPM
import React, { Component } from 'react';

class BlockNavigationButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
    };
  }

  handleClick = () => {
    this.setState({ hovered: false });
    this.props.onClick();
  };

  handleMouseEnter = () => {
    this.setState({ hovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ hovered: false });
  };

  render() {
    const { hovered } = this.state;
    const { className, disabled } = this.props;
    const classes = `BlockNavigationButton ${className} ${
      hovered ? 'hovered' : ''
    }`;
    let mouseEvents = {};
    if (!disabled) {
      mouseEvents = {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
      };
    }
    return (
      <button
        {...this.props}
        className={classes}
        onClick={this.handleClick}
        {...mouseEvents}
      >
        {this.props.children}
      </button>
    );
  }
}

export default BlockNavigationButton;



// WEBPACK FOOTER //
// ./src/Components/Pages/Survey/BlockNavigationButton.js